module.exports = __webpack_public_path__ + "img/poster.dc417e9c.svg";